import React from 'react'

export default function Home() {
  return (
   
      <div className='container
      '>
           <h1 className='my-3'>Welcome to the home section!!! </h1>
           <h2 className='my-3'>Mr. PK, Sahil, Lovekesh, Nabarun & <span style={{color:"#006400"}}>Punam</span>
             <div className='my-3'>you guys are amazing let's have a clap for yourself.</div></h2>
      </div>
       
      
    
  );
}
